import { getApp } from "firebase/app";
import { getFunctions, httpsCallable } from "firebase/functions";
import type {
  GetAuthUsersRequest,
  GetAuthUsersResponse,
} from "./authUsers";

export async function fetchAuthUsers(
  request: GetAuthUsersRequest
): Promise<GetAuthUsersResponse> {
  const functions = getFunctions(getApp());
  const callable = httpsCallable<GetAuthUsersRequest, GetAuthUsersResponse>(
    functions,
    "getAuthUsers"
  );
  const result = await callable(request);
  return result.data;
}
